const access = {
  entities: [
    { label: 't(Contacts)', code: 'contacts' },
    { label: 't(Lists)', code: 'lists' }
  ], 
  rights: [] 
}

export default access
